import React, { useEffect } from 'react';
import { LuBookOpenCheck,  } from "react-icons/lu";
import { TbWorld } from "react-icons/tb";
import { FaChartBar, FaDollarSign, FaCog, FaHeadset } from "react-icons/fa";
import { CiBank } from "react-icons/ci";
import { MdLogout } from "react-icons/md";
import logo from '../../assests/Images/Logo-Blue.svg'
import {NavLink } from 'react-router-dom'
import { useNavigate } from "react-router-dom";
import { ToastContainer } from 'react-toastify';

export default function SideMenu({isOpen , setIsOpen}) {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const handleLogout =() => {
    localStorage.clear();
    setIsOpen(false);
    navigate('/')

  }
  
  useEffect(()=>{
    if (!token) {
       navigate('/')
    }
  },[token , navigate])

  const handleNavClick = () => {
  if (window.innerWidth < 768) { // Tailwind's md breakpoint is 768px
    setIsOpen(false);
  }
};

  return (
    <>
    
    <ToastContainer/>
    <div 
      className={`
        bg-black border-r border-border text-white w-[280px] h-screen flex flex-col justify-between
        transition-transform duration-300
        fixed z-[9999] top-0 left-0
        md:static md:translate-x-0
        ${isOpen ? 'translate-x-0' : '-translate-x-full'}
      `}
    >
      
      <div className=" h-full">
        <div className="text-2xl flex font-bold px-3 py-4 border-b border-border">
          <img src={logo} alt="" className="w-20 mx-auto" />
        </div>
        <nav className="mt-4 flex flex-col space-y-2 px-2">
          <NavLink to="/Sessions" onClick={handleNavClick} className={({ isActive }) =>
            ` w-full flex  gap-2 items-center text-md text-nowrap px-3 py-2 hover:bg-[#fafaf930] ${isActive ? '  border-secondary bg-secondary ' : ''}`
          }> <LuBookOpenCheck className="mt-[3px]"/>Sessions</NavLink>
          <NavLink to="/BankRoll" onClick={handleNavClick} className={({ isActive }) =>
            ` w-full flex  gap-2 items-center text-md text-nowrap px-3 py-2 hover:bg-[#fafaf930] ${isActive ? '  border-secondary bg-secondary ' : ''}`
          }> <CiBank className="mt-[2px]"/>Bankroll</NavLink>
          <NavLink to="/Profitability" onClick={handleNavClick} className={({ isActive }) =>
            ` w-full flex  gap-2 items-center text-md text-nowrap px-3 py-2 hover:bg-[#fafaf930] ${isActive ? '  border-secondary bg-secondary ' : ''}`
          }> <FaChartBar className="mt-[3px]"/>Performance</NavLink>
          <NavLink to="/Locations" onClick={handleNavClick} className={({ isActive }) =>
            ` w-full flex  gap-2 items-center text-md text-nowrap px-3 py-2 hover:bg-[#fafaf930] ${isActive ? '  border-secondary bg-secondary ' : ''}`
          }> <TbWorld className="mt-[3px]"/>Locations</NavLink>
          <NavLink to="/Transactions" onClick={handleNavClick} className={({ isActive }) =>
            ` w-full flex  gap-2 items-center text-md text-nowrap px-3 py-2 hover:bg-[#fafaf930] ${isActive ? '  border-secondary bg-secondary ' : ''}`
          }> <FaDollarSign className="mt-[3px]"/>Transactions </NavLink>
          <NavLink to="/Settings" onClick={handleNavClick} className={({ isActive }) =>
            ` w-full flex  gap-2 items-center text-md text-nowrap px-3 py-2 hover:bg-[#fafaf930] ${isActive ? '  border-secondary bg-secondary ' : ''}`
          }> <FaCog className="mt-[3px]"/>Settings</NavLink>
          <NavLink to="/Support" onClick={handleNavClick} className={({ isActive }) =>
            ` w-full flex  gap-2 items-center text-md text-nowrap px-3 py-2 hover:bg-[#fafaf930] ${isActive ? '  border-secondary bg-secondary ' : ''}`
          }> <FaHeadset className="mt-[3px]"/>Support</NavLink> 
          
        </nav>
      </div>
      <button className="text-red-500 flex items-center gap-2 border-t px-3 py-3 border-border hover:bg-[#fafaf930]"
        onClick={handleLogout}
      >
        <MdLogout /> Logout
      </button>

    </div>
    </>
  );
}
